import { jobs } from '../behavior/jobs-sidecar'
import { stevieCam } from '../engine/stevieCam-sidecar'
import { l } from '../lib/imports'
import { gameRunner } from '../main/gameRunner-sidecar'
import { scene } from '../main/scene-sidecar'
import { cursors } from '../ui/cursors-sidecar'
import { textInputs } from '../uiParts/textInputs-sidecar'

import { uiLevelSelect } from '../ui/uiLevelSelect-sidecar'
import { uiMode } from '../ui/uiMode-sidecar'
import { uiNewMap } from '../ui/uiNewMap-sidecar'
import { uiOpenMap } from '../ui/uiOpenMap-sidecar'
import { uiPreferences } from '../ui/uiPreferences-sidecar'
import { common } from './../main/common-sidecar'
import { uiSpeedBar } from '../ui/uiSpeedBar-sidecar'
import { tileMapEditor } from '../editor/tileMapEditor-sidecar'
import { testRigCreator } from '../tests/testRigCreator-sidecar'

let keys = {
  leftThruster: false,
  rightThruster: false,

  godMode: false,
}

export const getKeys = () => {
  return keys
}

export const create = () => {
  let s = common.getPhaserScene()

  l.forEach(textInputs.textInputAlphabet, (c) => {
    s.input.keyboard.addKey(c)
  })

  // scene.input.keyboard.addKeys('1,2,3,4,5,6,o,n')

  // scene.input.keyboard.addKeys('a,d')
  s.input.keyboard.addKeys('?,/')
  s.input.keyboard.on('keydown', (event: any) => {
    console.log(
      'key down',
      'key',
      event.key,
      'keyCode',
      event.keyCode,
      'code',
      event.code,
    )
    let ctx = scene.getContext()

    if (textInputs.hasFocus()) {
      textInputs.handleKeyboardInput(event.key, event.keyCode, event.code)
    } else {
      if (event.code === 'NumpadAdd') {
        testRigCreator.createNextTestRig()
      }
      if (event.code === 'NumpadSubtract') {
        testRigCreator.createPrevTestRig()
      }

      if (event.key === '1') {
        tileMapEditor.setMode('structures')
      }
      if (event.key === '2') {
        tileMapEditor.setMode('shadows')
      }
      if (event.key === '3') {
        tileMapEditor.setMode('floors')
      }
      if (event.key === '4') {
        tileMapEditor.setMode('objects')
      }
      if (event.key === '5') {
        tileMapEditor.setMode('doors')
      }
      if (event.key === '6') {
        tileMapEditor.setMode('ui')
      }
      if (event.key === '7') {
        tileMapEditor.setMode('test')
      }
      if (event.key === '8') {
        tileMapEditor.setMode('deconstruct-hull')
      }
      if (event.key === '0') {
        tileMapEditor.setMode('none')
      }

      if (event.key === 'q') {
        stevieCam.setZoom(1)
      }
      if (event.key === 'e') {
        stevieCam.setZoom(0.5)
      }

      if (event.key === 'o') {
        uiOpenMap.open()
      }
      if (event.key === 'l') {
        uiLevelSelect.open()
      }
      if (event.key === 'r') {
        gameRunner.doRetry()
      }
      if (event.key === 'n') {
        uiNewMap.toggle()
      }
      if (event.key === 'j') {
        jobs.report()
      }
      if (event.key === 'm') {
        stevieCam.shake()
      }
      if (event.key === 'p' || event.key === '?' || event.keyCode === '/') {
        uiPreferences.toggle()
      }
      if (event.key === 'Escape') {
        // console.log('handle esc')
        uiMode.closeDialogs()

        cursors.clear(scene.getContext().cursor)
      }

      if (event.code === 'Space') {
        uiSpeedBar.togglePause()
      }

      // if (event.key === 't') {
      //   let t = tileMap.getTileAtMouse(
      //     ctx.map,
      //     s.input.mousePointer.x,
      //     s.input.mousePointer.y,
      //   )
      //   if (t) {
      //     pathHighligher.findPath(3, 3, t.i, t.j)
      //   }
      // }

      // if (
      //   event.code === 'ControlLeft' ||
      //   event.code === 'ArrowLeft' ||
      //   event.key === 'a'
      // ) {
      //   console.log('left control')
      //   keys.leftThruster = true
      // }
      // if (
      //   event.code === 'ControlRight' ||
      //   event.code === 'ArrowRight' ||
      //   event.key === 'd'
      // ) {
      //   console.log('right control')
      //   keys.rightThruster = true
      // }
      // if (event.key === 'k') {
      //   // console
      //   // monsters.killAllNonPlayer()
      // }

      if (event.code === 'ControlLeft') {
        console.log('left control d')
        keys.godMode = true
      }
    }
  })

  s.input.keyboard.on('keyup', (event: any) => {
    if (event.code === 'ControlLeft') {
      console.log('left control u')
      keys.godMode = false
    }

    // console.log('key up', event.key, event.keyCode, event.code)
    // if (
    //   event.code === 'ControlLeft' ||
    //   event.code === 'ArrowLeft' ||
    //   event.key === 'a'
    // ) {
    //   console.log('left control')
    //   keys.leftThruster = false
    // }
    // if (
    //   event.code === 'ControlRight' ||
    //   event.code === 'ArrowRight' ||
    //   event.key === 'd'
    // ) {
    //   console.log('right control')
    //   keys.rightThruster = false
    // }
    // if (event.key === 'k') {
    //   // console
    //   // monsters.killAllNonPlayer()
    // }
  })
}
